import React, { Component } from 'react';
import ReactSVG from 'react-svg';

import listSocial from './listSocial';
import './SocialIcons.css';

class SocialIcons extends Component {
  /*
  *   ReferenceError: SVGSVGElement is not defined => when npm run test
  *   Using wrapper svg
  */
  static renderListSocial() {
    if (process.env.REACT_APP_TEST === 'true') {
      return null;
    } else {
      return (
        listSocial.map((social, i) =>
          (<li key={i}>
            <a href={social.path} target="_blank"><ReactSVG path={social.icon} className={social.name}/></a>
          </li>))
      );
    }
  }

  render() {
    return (
      <ul className="c-social-icons">
        {SocialIcons.renderListSocial()}
      </ul>
    );
  }
}

export default SocialIcons;



// WEBPACK FOOTER //
// ./src/components/common/socialIcons/SocialIcons.jsx